module.exports = __webpack_public_path__ + "img/ice-texture.988666bb.png";